'use client';

import { useState, useEffect, useCallback } from 'react';

type Testimonial = {
  quote: string;
  name: string;
  brand: string;
  avatar: string;
};

const testimonialsFr: Testimonial[] = [
  {
    quote:
      "Cindy travaille très efficacement, avec une organisation pensée pour faire gagner du temps à ses clients. Elle s'approprie votre marque et lui apporte une dimension engageante pour que votre voix porte vraiment sur les réseaux sociaux.",
    name: 'Emmanuelle P.',
    brand: 'Social Media Lab',
    avatar: '👩‍💼',
  },
  {
    quote:
      'Nous avons essayé un grand nombre de community-manager avant de tomber sur la perle rare, Cindy !',
    name: 'William',
    brand: 'Snoofield',
    avatar: '👨‍💻',
  },
  {
    quote:
      "J'ai confié toute ma communication à Cindy. Depuis plusieurs mois, je suis hyper satisfaite de ce qu'elle fait sur mes réseaux sociaux. Les posts sont géniaux, bien écrits, très divers.",
    name: 'Alison R.',
    brand: 'DogShop',
    avatar: '👩‍🦰',
  },
  {
    quote:
      "It's a pleasure to work with Cindy on Dos Maderas. She has expertise and a real knowledge to help us conquest the french market.",
    name: 'Chelsea',
    brand: 'Dos Maderas',
    avatar: '👩‍💼',
  },
  {
    quote:
      "Cindy est une partenaire de confiance. À l'écoute et très réactive, elle sait s'adapter et être de bons conseils.",
    name: 'Amandine',
    brand: 'BeTrue',
    avatar: '👩',
  },
  {
    quote:
      "J'ai beaucoup aimé collaborer avec Cindy sur une mission de gestion de réseaux sociaux et création de contenu. Dotée d'une grande créativité, elle sublime vos réseaux sociaux et vos contenus avec une identité pop bien maîtrisée !",
    name: 'Samar',
    brand: '',
    avatar: '👩‍🎨',
  },
  {
    quote: "Ça change tout de t'avoir ET merci de ta réactivité sur le Reel de ce matin 🙏🏻",
    name: 'Claire',
    brand: 'WTS',
    avatar: '👩‍💻',
  },
  {
    quote: "Hello, de l'avis GÉNÉRAL et a l'unanimité c'est...... SUPER !!!!",
    name: 'Thierry',
    brand: 'Mainkind',
    avatar: '👨‍💼',
  },
];

const testimonialsEn: Testimonial[] = [
  {
    quote:
      'Cindy works very efficiently, with a way of organising things that saves her clients time. She takes ownership of your brand and gives it an engaging dimension so your voice really carries on social media.',
    name: 'Emmanuelle P.',
    brand: 'Social Media Lab',
    avatar: '👩‍💼',
  },
  {
    quote: 'We tried a great many community managers before finding the rare gem, Cindy!',
    name: 'William',
    brand: 'Snoofield',
    avatar: '👨‍💻',
  },
  {
    quote:
      'I handed my whole communication over to Cindy. For several months now I have been extremely happy with what she does on my social media. The posts are brilliant, well written and wonderfully varied.',
    name: 'Alison R.',
    brand: 'DogShop',
    avatar: '👩‍🦰',
  },
  {
    quote:
      "It's a pleasure to work with Cindy on Dos Maderas. She has expertise and a real knowledge to help us conquest the french market.",
    name: 'Chelsea',
    brand: 'Dos Maderas',
    avatar: '👩‍💼',
  },
  {
    quote:
      'Cindy is a partner you can trust. Attentive and highly responsive, she knows how to adapt and gives genuinely good advice.',
    name: 'Amandine',
    brand: 'BeTrue',
    avatar: '👩',
  },
  {
    quote:
      'I really enjoyed working with Cindy on a social media management and content creation project. Hugely creative, she elevates your channels and your content with a well-crafted pop identity!',
    name: 'Samar',
    brand: '',
    avatar: '👩‍🎨',
  },
  {
    quote:
      'Having you makes all the difference, and thank you for turning that Reel around so fast this morning 🙏🏻',
    name: 'Claire',
    brand: 'WTS',
    avatar: '👩‍💻',
  },
  {
    quote: 'Hello, the unanimous verdict is...... BRILLIANT!!!!',
    name: 'Thierry',
    brand: 'Mainkind',
    avatar: '👨‍💼',
  },
];

const PER_PAGE = 3;
const TOTAL_PAGES = Math.ceil(testimonialsFr.length / PER_PAGE);
const AUTO_DELAY = 6000;

export default function TestimonialsCarousel({ locale }: { locale?: string }) {
  const allTestimonials = locale === 'en' ? testimonialsEn : testimonialsFr;
  const [page, setPage] = useState(0);
  const [visible, setVisible] = useState(true);

  const goTo = useCallback((next: number) => {
    setVisible(false);
    setTimeout(() => {
      setPage(next);
      setVisible(true);
    }, 280);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((page + 1) % TOTAL_PAGES);
    }, AUTO_DELAY);
    return () => clearInterval(timer);
  }, [page, goTo]);

  const cards = allTestimonials.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

  return (
    <>
      <div
        className="t-tgrid"
        style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.28s ease' }}
      >
        {cards.map((t, i) => (
          <div key={`${page}-${i}`} className="t-tcrd">
            <div className="t-tstars">★★★★★</div>
            <p className="t-tquote">&#34;{t.quote}&#34;</p>
            <div className="t-tauth">
              <div className="t-tavatar-ring">
                <div className="t-tavatar-inner">{t.avatar}</div>
              </div>
              <div>
                <div className="t-tname">{t.name}</div>
                {t.brand && <div className="t-tbrand">{t.brand}</div>}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '24px' }}>
        {Array.from({ length: TOTAL_PAGES }).map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            aria-label={`Page ${i + 1}`}
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              background: i === page ? '#1a1a1a' : '#d1d1d1',
              transition: 'background 0.3s',
            }}
          />
        ))}
      </div>
    </>
  );
}
